import OnboardingCardBackground from '@assets/icons/onboarding-card-background.svg';
import OnboardingCardImage from '@assets/icons/onboarding-card-image.svg';
import React from 'react';
import { Card, Props as CardProps } from './card';
import { SCREEN_PADDING_SMALL, ThemedSVGProps } from '@/styles';
import { StyleSheet, View } from 'react-native';
import { useTheme } from '@/contexts/theme-context';

type Props = {
  iconProps?: ThemedSVGProps;
  ImageComponent?: React.ComponentType;
  showBackground?: boolean;
} & CardProps;

export const EmptyStateCard: React.FC<Props> = ({
  children,
  iconProps = {},
  ImageComponent = OnboardingCardImage,
  showBackground = true,
  ...cardProps
}) => {
  const theme = useTheme();
  return (
    <View style={styles.base}>
      <Card {...cardProps}>
        {showBackground ? (
          <View style={styles.backgroundContainer}>
            <OnboardingCardBackground fill={theme.colors.accent} />
          </View>
        ) : null}
        <View style={styles.content}>
          <View style={styles.imageContainer}>
            <ImageComponent fill={theme.colors.primary} {...iconProps} />
          </View>
          {children}
        </View>
      </Card>
    </View>
  );
};

const styles = StyleSheet.create({
  backgroundContainer: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
  },
  base: {
    paddingHorizontal: SCREEN_PADDING_SMALL,
    paddingVertical: SCREEN_PADDING_SMALL,
  },
  content: {
    alignItems: 'center',
    overflow: 'hidden',
    paddingBottom: 24,
    paddingHorizontal: 24,
    paddingTop: 48,
  },
  imageContainer: {
    marginBottom: 32,
  },
});
